import { useQuery } from 'react-query'
import { ManagerService } from '~/api/services/manager'
import { onError } from '~/utils/helpers'

// Manager Profile

const getProfileData = () => useQuery(
  'manager-profile-data',
  ManagerService.getProfileData,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmersIndex = (data?) => useQuery(
  `manager-farmers-index-${JSON.stringify(data)}`,
  () => ManagerService.getFarmersIndex(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCollectionPointsIndex = (data?) => useQuery(
  `manager-collection-points-index-${JSON.stringify(data)}`,
  () => ManagerService.getCollectionPointsIndex(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

// Deliveries

const getDeliveriesIndexData = () => useQuery(
  'manager-deliveries-index-data',
  ManagerService.getDeliveriesIndexData,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getDeliveriesIndex = (data?) => useQuery(
  `manager-deliveries-index-${JSON.stringify(data)}`,
  () => data?.month && ManagerService.getDeliveriesIndex(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

// Qualities

const getMilkTestsIndexData = () => useQuery(
  'manager-milk-tests-index-data',
  ManagerService.getMilkTestsIndexData,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkTestsIndex = (data?) => useQuery(
  `manager-milk-tests-index-${JSON.stringify(data)}`,
  () => data && ManagerService.getMilkTestsIndex(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

// Milk Payments

const getMilkInvoicesIndex = (data?) => useQuery(
  `manager-milk-invoices-index-${JSON.stringify(data)}`,
  () => data?.month && ManagerService.getMilkInvoicesIndex(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const ManagerQuery = {
  getProfileData,
  getFarmersIndex,
  getCollectionPointsIndex,
  getDeliveriesIndexData,
  getDeliveriesIndex,
  getMilkTestsIndexData,
  getMilkTestsIndex,
  getMilkInvoicesIndex
}
